const subheadingsData = {
  1: [
    {
      title: "About Me",
      content: (
        <>
          <p>
          Full-stack developer with  over 3 years of experience as a UI/UX designer, I seamlessly merge design aesthetics with robust technical solutions.
          </p>
        </>
      ),
    },
  ],
  2: [
    {
      title: "2024 Bachelor's Degree",
      content: (
        <>
          <p>
          Bachelor's degree in software engineering(cyber security) from Addis Ababa University.
          </p>
        </>
      ),
    },
    
  ],
  3: [
    {
      title: "2022 UI/UX Designer",
      content: (
        <>
          <p>
          I’ve worked as a UI/UX Designer with the Aladia Siri team in Italy and Hewa Technology in Ethiopia.
          </p>
        </>
      ),
    },
    {
      title: "2023 Web Developer",
      content: (
        <>
          <p>
          I’ve worked as a web developer using React at Hewa Technology, where I created a standout hotel website involving both backend (Node.js) and frontend development.
          </p>
        </>
      ),
    },
    {
      title: "2024 Mobile application Developer",
      content: (
        <>
          <p>
            I’ve worked as a web developer using React at Hewa Technology, where I created a standout hotel website.
          </p>
        </>
      ),
    },
    {
      title: "2023 Graphics Designer",
      content: (
        <>
          <p>
          I worked as a graphics designer at Creative Hub in Ethiopia, utilizing Adobe Photoshop, Adobe Illustrator, and other design tools.
          </p>
        </>
      ),
    },
  ],
};

export default subheadingsData;
